<template>
  <div class="content content2">
      <p class="nav">#<span>管理团队</span></p>
      <ul class="team1">
        <li v-for="(item, index) in teamList" :key="index">
          <div class="main" :class="{ 'expanded': expandedCards[`team1-${index}`] }" @click="toggleCard(`team1-${index}`)">
            <div class="head">
              <span class="head-pic"><img :src="item.pic" alt="" ></span>
              <div class="info">
                <span class="name">{{item.name}}</span>
                <span>{{item.intro1}}</span>
                <span>{{item.intro2}}</span>
              </div>
              <img src="./symbol.png" alt="" class="symbol">
            </div>
            <div class="introduction" :class="{ 'collapsed': !expandedCards[`team1-${index}`] }" :ref="`intro-team1-${index}`">
              <div v-for="(items, idx) in item.introduction" :key="idx"
                   :class="{ 'intro-title': items.type === 'title', 'intro-content': items.type === 'content' }">
                {{items.text}}
              </div>
              <div v-if="!expandedCards[`team1-${index}`] && isContentOverflowing(`team1-${index}`)" class="ellipsis">...</div>
            </div>
          </div>
        </li>
      </ul>
      <ul class="team">
        <li v-for="(item, index) in teamList2" :key="index">
          <div class="main" :class="{ 'expanded': expandedCards[`team2-${index}`] }" @click="toggleCard(`team2-${index}`)">
            <div class="head">
              <span class="head-pic"><img :src="item.pic" alt=""></span>
              <div class="info">
                <span class="name">{{item.name}}</span>
                <span>{{item.intro1}}</span>
                <span>{{item.intro2}}</span>
              </div>
              <img src="./symbol.png" alt="" class="symbol">
            </div>
            <div class="introduction" :class="{ 'collapsed': !expandedCards[`team2-${index}`] }" :ref="`intro-team2-${index}`">
              <div v-for="(items, idx) in item.introduction" :key="idx"
                   :class="{ 'intro-title': items.type === 'title', 'intro-content': items.type === 'content' }">
                {{items.text}}
              </div>
              <div v-if="!expandedCards[`team2-${index}`] && isContentOverflowing(`team2-${index}`)" class="ellipsis">...</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
import pic1 from './tx_cqw.png'
import pic2 from './tx_zq.png'
import pic3 from './tx_zzh.png'

import pic5 from './tx_gr.png'
export default {
  name: 'Team',
  data () {
    return {
      // 记录每个卡片的展开状态
      expandedCards: {},
      teamList: [
        {
          id: 0,
          pic: pic1,
          name: '陈琦伟 教授',
          intro1: '亚商资本创始合伙人',
          intro2: '亚商集团创始人&董事长',
          introduction: [
            { type: 'content', text: '投资银行和资本市场专家，亚布力企业家论坛理事。上海新沪商联合会轮值主席，多家金融机构和上市独立董事；上海交通大学安泰经济与管理学院教授；中国创业资本研究中心主任；兼任中国国家开发银行顾问；上海证券交易所专家委员等社会要职。' },
            { type: 'content', text: '其专业代表作《国际竞争论》曾获"孙冶方经济学优秀著作奖"。' }
          ]
        },
        {
          id: 1,
          pic: pic2,
          name: '张琼 女士',
          intro1: '亚商资本创始合伙人',
          intro2: '亚商集团董事/总裁',
          introduction: [
            { type: 'content', text: 'ASE基金会创始人，投资人，艺术收藏家及赞助人，美国斯坦福大学商学院MsX管理学硕士，华东师范大学国际金融学硕士，华东政法大学国际经济法学士。作为7天连锁酒店（后更名为铂涛集团并被锦江集团收购）联合创始股东，以及百吉生物董事长/联合创始股东。' },
            { type: 'title', text: '基本信息' },
            { type: 'content', text: '中文名：张琼，英文名:Joan Zhang，性别:女，国籍:中国，民族:汉族' },
            { type: 'content', text: '毕业院校:美国斯坦福大学商学院， 职务:亚商资本创始合伙人，亚商集团董事/总裁' },
            { type: 'title', text: '人物履历' },
            { type: 'content', text: '早在90年代中国资本市场发展的早期就开始投身于企业股份制改造、股票发行和收购兼并，策划、主持和参与了数十起国有企业改制、战略性重组、并购整合以及海内外融资。' },
            { type: 'content', text: '2001年中国股权投资市场开始起步，张琼从斯坦福商学院毕业归来后联合创立了亚商资本，积极推动了很多地方的双创产业发展。' },
            { type: 'content', text: '张琼专注创新消费和消费升级领域以及生命技术和大健康领域的投资，拥有超过二十年的投资和创业经验，主导和参与多家高成长优质企业的股权投资。' },
            { type: 'title', text: '人物简介' },
            { type: 'content', text: '张琼在互联网创新消费及生命技术创新领域，拥有超过二十年的投资和创业经验，并于2022年在香港创立非营利性艺术基金会--ASE基金会（ASE Foundation）。' },
            { type: 'content', text: '曾任中国股权投资基金协会副会长、上海市创业投资行业协会理事、上海市金融青年联合会常委，并曾荣获由China Venture投中集团授予的“2010年中国最佳创业投资人”，融中2018年度最具人气女性投资家，连续多年入选“TOP 50投资人”，投资界2021 S50中国女性投资人等殊荣。' },
            { type: 'title', text: '人物报道' },
            { type: 'content', text: '聚焦"轻奢"踏准节点IRR超35%的亚商资本造"风口"' },
            { type: 'content', text: '亚商资本张琼：看好垂直化与个性化的连锁企业' },
            { type: 'content', text: '亚商资本张琼：创新消费，下一个黄金十年|2019中国投资人未来峰会' }
          ]
        },
        {
          id: 2,
          pic: pic3,
          name: '钟志辉 先生',
          intro1: '亚商资本管理合伙人',
          intro2: '',
          introduction: [
            { type: 'content', text: '深圳大学经济学学士，复旦大学MBA。在先进制造、健康医疗和TMT领域具有丰富的经验。' },
            { type: 'content', text: '专注金融及投资工作近20年。先后任职中国人民银行深圳外汇中心、Vision Capital China、和晟投资、绿景集团等公司，从事投资及相关管理工作，在业内具备广泛联系。钟志辉先生负责过美信水务、赋安安全、中泰模具、丝路数码、雅视科技等多个投资项目，熟悉境内外资本市场，精于企业分析，具有良好的项目判断和实战能力。' }
          ]
        }
      ],
      teamList2: [
        {
          id: 1,
          pic: pic5,
          name: '郭锐 先生',
          intro1: '亚商资本合伙人',
          intro2: '',
          introduction: [
            { type: 'content', text: '先后就读于北京工商大学、中央财经大学，并获投资学硕士学位。郭锐先生在IT及互联网领域有丰富的实业和投资经验，先后任职瀛海威、中国网通等公司，从事业务管理及投资工作，在业内具备广泛联系。' },
            { type: 'content', text: '郭锐先生曾负责风际网络、北京鼎合、DATAEYE、东信时代等多个TMT项目的投资及投后管理，对TMT行业有深入的理解及投资能力。' }
          ]
        }
      ]
    }
  },
  methods: {
    /**
    * 切换卡片的展开/收起状态
    * @param {string} cardId - 卡片的唯一标识
    */
    toggleCard (cardId) {
      this.$set(this.expandedCards, cardId, !this.expandedCards[cardId])
    },

    /**
     * 检测内容是否溢出容器高度
     * @param {string} cardId - 卡片的唯一标识
     * @returns {boolean} 是否溢出
     */
    isContentOverflowing (cardId) {
      // 根据团队成员的内容长度来判断是否需要显示省略号
      const teamMember = this.getTeamMemberById(cardId)
      if (!teamMember) return false

      // 计算总字符数，适配新的对象格式
      const totalLength = teamMember.introduction.reduce((total, item) => {
        return total + (item.text ? item.text.length : 0)
      }, 0)
      return totalLength > 200 // 大约2-3行的内容长度
    },

    /**
     * 根据卡片ID获取团队成员信息
     * @param {string} cardId - 卡片的唯一标识
     * @returns {object|null} 团队成员信息
     */
    getTeamMemberById (cardId) {
      const [teamType, index] = cardId.split('-')
      const idx = parseInt(index)

      if (teamType === 'team1') {
        return this.teamList[idx] || null
      } else if (teamType === 'team2') {
        return this.teamList2[idx] || null
      }
      return null
    }
  }
}
</script>

<style scoped>
.content2{
  margin-bottom: 150px;
  background: url('../../assets/bg_dot.jpg');
  padding: 140px 64px 5px 64px;
  min-width: 1200px;
  /* box-sizing: border-box; */
}
.content2 .nav{
  padding: 0 120px 0 174px;
}
.content2 .nav{
  font-size: 24px;
  color: #c70016;
  font-weight: 600;
  margin-bottom: 30px;
}
.content2 .nav span{
  font-weight: 600;
  color: #333367;
}
.content2 ul{
  width: 100%;
  display: table;
  table-layout: fixed;
  padding-top: 123px;
  /* height: 412px; */
}
.content2 ul.team1{
  min-width: 1200px;
}
.content2 ul li{
  display: table-cell;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
}
.content2 ul li .main{
  background: #fff;
  box-shadow: 0 0 16px 10px rgba(0, 0, 0, 0.03);
  display: inline-block;
  vertical-align: middle;
}
.content2 ul li .main{
   width: 95%;
   /* width: 484px; */
   /* min-width: 408px; */
   min-width: 380px;
   height: 332px;
   padding-left: 5%;
   box-sizing: border-box;
   position: relative;
   font-size: 14px;
   transition: height 0.3s ease;
}

/* 展开状态的卡片高度自适应 */
.content2 ul li .main.expanded {
   height: auto;
   min-height: 332px;
}
.content2 .team{
  max-width: 520px;
  margin: 0;
  text-align: left;
}
.content2 ul li:hover{
  transform: translateY(-18px);
  -webkit-transform: translateY(-18px);
  -moz-transform: translateY(-18px);
}
.content2 ul li:last-child{
  margin-right: 0;
}
.content2 .head{
  padding-top: 26px;
  height: 67px;
  margin-bottom: 22px;
}
.content2 .team .head{
  margin-bottom: 32px;
}
.content2 .head .head-pic{
  position: absolute;
  top: -86px;
  left: 32px;
  width: 40%;
}
/* .content2 .team .head .secondTe{
  position: absolute;
  top: -93px;
  left: 32px;
} */
.content2 .head .head-pic img{
  width: 100%;
}
.content2 .head .symbol{
  position: absolute;
  top: 38px;
  right: 2%;
}
.content2 .info{
  /* margin-left: 195px; */
  margin-left: 45%;
  text-align: left;
}
.content2 .info span{
  display: block;
  line-height: 20px;
  color: #373737;
}
.content2 .info .name{
  margin-bottom: 10px;
  font-size: 28px;
}
.content2 .introduction{
  padding-right: 32px;
  line-height: 20px;
  color: #3e3e3e;
  text-align: left;
  position: relative;
}

/* 标题样式 - 加粗、左对齐、无缩进 */
.content2 .introduction .intro-title {
  font-weight: bold;
  font-size: 15px;
  color: #333367;
  margin: 12px 0 8px 0;
  text-indent: 0;
  line-height: 22px;
}

/* 正文样式 - 保持原有的缩进和样式 */
.content2 .introduction .intro-content {
  text-indent: 2em;
  margin-bottom: 8px;
  line-height: 20px;
}

/* 收起状态的介绍内容 */
.content2 .introduction.collapsed {
  max-height: 160px;
  overflow: hidden;
  position: relative;
}

/* 省略号样式 */
.content2 .introduction .ellipsis {
  position: absolute;
  bottom: 0;
  right: 32px;
  background: #fff;
  padding-left: 10px;
  font-weight: bold;
  color: #666;
  cursor: pointer;
}
@media screen and (max-width: 1480px){
  .content2{
    box-sizing: border-box;
  }
  .content2 .team1 .head .head-pic{
    top: -55px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/team/team.vue